import { Badge } from "@/components/ui/badge";

import { callStatusToLabel } from "@/lib/constants";
import { CallStatus } from "@/types";

export const StatusBadge = ({ status }: { status: CallStatus }) => {
  const label = callStatusToLabel[status];

  /* Render */
  const render = () => {
    switch (status) {
      case CallStatus.ANSWERED:
      case CallStatus.COMPLETED:
      case CallStatus.IN_PROGRESS:
      case CallStatus.INITIATED:
      case CallStatus.RINGING:
        return (
          <Badge variant="secondary" className="bg-green-100 text-green-700">
            {label}
          </Badge>
        );
      case CallStatus.ABANDONED:
      case CallStatus.CANCELED:
      case CallStatus.FAILED:
        return (
          <Badge variant="secondary" className="bg-red-100 text-red-700">
            {label}
          </Badge>
        );
      case CallStatus.BUSY:
      case CallStatus.FORWARDED:
      case CallStatus.MISSED:
      case CallStatus.NO_ANSWER:
      case CallStatus.QUEUED:
        return (
          <Badge variant="secondary" className="bg-blue-100 text-blue-700">
            {label}
          </Badge>
        );
      default:
        return (
          <Badge variant="secondary" className="bg-slate-100 text-slate-700">
            {label}
          </Badge>
        );
    }
  };

  return render();
};
